import { render, staticRenderFns } from "./RiskManagement.vue?vue&type=template&id=150e254b&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e254b",
  null
  
)

export default component.exports